module.exports = __webpack_public_path__ + "static/section-bg-3d7b0eac45aab5ee2cf387b6aa671f1b.png";